<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">">
            <template slot="item" slot-scope="props">
              <router-link
                :to="'/' + props.item.to"
                :disabled="props.item.disabled"
                v-bind:class="{
                  'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                    props.item.disabled,
                }"
                >{{ props.item.text }}</router-link
              >
            </template>
          </v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">{{ responseError }}</span>
            </v-flex>
            <v-flex sm4 v-if="!user.shopId">
              <ShopMultiSelect :ids="queryParams.shopIds" @set="setShop" />
            </v-flex>
            <v-flex sm4>
              <v-select
                v-model="queryParams.financeSettingId"
                :items="financeSettingList"
                color="blue-grey lighten-2"
                label="Choose Finance Setting..."
                item-text="financialYearName"
                menu-props="auto"
                item-value="id"
                @input="bindMonth(queryParams.financeSettingId)"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.fromMonth"
                    label="From Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.fromMonth"
                  :min="minMonth"
                  :max="maxMonth"
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.toMonth"
                    label="To Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="queryParams.toMonth"
                  :min="minMonth"
                  :max="maxMonth"
                  type="month"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-radio-group
                v-model="queryParams.balanceType"
                @change="previewFilterObj.balanceType = queryParams.balanceType"
                :mandatory="false"
                row
              >
                <v-radio label="All" value="ALL"></v-radio>
                <v-radio label="With Balance" value="WITHBALANCE"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">Preview</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1" style="overflow-x: auto; max-width: 100%;">
        <v-card style="width: fit-content;">
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <h3 style="margin:0px;color:blue" id="counter">
                Manufacturing Account
              </h3>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >
                Shop Code : {{ shopCode }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >
                Date : {{ currentDate }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <v-layout row pt-4>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Account Code
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Account Name
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Nature</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Total Budget
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Total Budget(%)
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Amount</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">Amount(%)</h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Difference Budget
                  </h4>
                </div>
              </v-flex>
              <v-flex xs2>
                <div style="float:left;padding-left:1px">
                  <h4 style="margin:0px;color:blue" id="counter">
                    Difference Budget(%)
                  </h4>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 ml-2>
            <div style="width:100%;height:3px;background-color: blue;"></div>
          </v-flex>

          <!-- Start ORIGINAL_COST -->
          <manufacturing-account-session
            :sessionName="'Original Cost'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'ORIGINAL_COST' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.originalCost"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.originalCostBudget"
            :showListLoading="showListLoading"
          />
          <!-- END ORIGINAL_COST -->

          <!-- Start PRODUCTION_COST -->
          <manufacturing-account-session
            :sessionName="'Production Cost'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'PRODUCTION_COST' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.productionCost"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.productionCostBudget"
            :showListLoading="showListLoading"
            :footer="'Total Production Cost'"
            :footerAmount="manufacturingAccount.totalProductionCost"
            :footerBudget="manufacturingAccount.totalProductionCostBudget"
            :useBgColor="true"
          />
          <!-- END PRODUCTION_COST -->

          <!-- Start PRODUCTION_VALUE -->
          <manufacturing-account-session
            :sessionName="'Production Value'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'PRODUCTION_VALUE' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.productionValue"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.productionValueBudget"
            :showListLoading="showListLoading"
            :footer="'Total Production Value'"
            :footerAmount="manufacturingAccount.totalProductionValue"
            :footerBudget="manufacturingAccount.totalProductionValueBudget"
            :useBgColor="true"
          />
          <!-- END PRODUCTION_VALUE -->

          <!-- Start VALUE_OF_GOODS_SOLD -->
          <manufacturing-account-session
            :sessionName="'Value Of Goods Sold'"
            :accountList="
              manufacturingAccount.manufacturingParentAccountList.filter(
                (v) =>
                  v.sessionName === 'VALUE_OF_GOODS_SOLD' &&
                  (queryParams.balanceType == 'ALL' ? true : v.totalAmount != 0)
              )
            "
            :calculatePercentage="false"
            :baseAmount="manufacturingAccount.totalValueOfGoodsSold"
            :sessionTotalAmount="manufacturingAccount.valueOfGoodsSold"
            :baseBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :sessionTotalBudget="manufacturingAccount.valueOfGoodsSoldBudget"
            :showListLoading="showListLoading"
            :footer="'Value Of Goods Sold'"
            :footerAmount="manufacturingAccount.totalValueOfGoodsSold"
            :footerBudget="manufacturingAccount.totalValueOfGoodsSoldBudget"
            :useBgColor="true"
          />
          <!-- END VALUE_OF_GOODS_SOLD -->


        </v-card>
      </v-flex>

      <v-flex sm12>
        <div class="text-xs-center">
          <v-btn color="error" @click="clear">
            Reset
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            :loading="saveLoading"
            @click="printInvoice('Print')"
          >
            Print
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn
            color="success"
            :loading="exportLoading"
            @click="exportMAPreview()"
          >
            Export
            <v-icon right>description</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- MA print hidden area -->
    <manufacturingAccountPrint
      id="Print"
      :maModel="manufacturingAccount"
      :fromMonth="queryParams.fromMonth"
      :toMonth="queryParams.toMonth"
      :shopCode="shopCode"
      :shopName="shopName"
      :balanceType="queryParams.balanceType"
    ></manufacturingAccountPrint>

    <!-- End print  -->
  </v-container>
</template>
<script>
import { manufacturingAccountService } from "../../services/manufacturing-account-service";
import { ManufacturingAccount } from "../../models/model";
import { commonService } from "../../services/common-service";
import { financeSettingService } from "../../services/finance-setting-service";
import manufacturingAccountPrint from "./ManufacturingAccountPrint.vue";
import ManufacturingAccountSession from "./ManufacturingAccountSession.vue";
import ShopMultiSelect from "../templates/ShopMultiSelect.vue";
export default {
  name: "IncomeStatementPreview",
  components: {
    ShopMultiSelect,
    manufacturingAccountPrint,
    ManufacturingAccountSession,
  },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    exportLoading: false,
    breadcrumbs: [
      {
        text: "Manufacturing Account",
        disabled: true,
      },
      {
        text: "Manufacturing Account Preview",
        disabled: true,
      },
    ],
    queryParams: {
      shopIds: [],
      fromMonth: new Date().toISOString().substr(0, 7),
      toMonth: new Date().toISOString().substr(0, 7),
      balanceType: "ALL",
    },
    currentDate: new Date().toISOString().slice(0, 10),
    responseError: "",
    saveLoading: false,
    shopCode: "",
    shopName: "",
    financeSettingList: [],
    minMonth: "",
    maxMonth: "",
    manufacturingAccount: new ManufacturingAccount(),
    oldManufacturingAccount: new ManufacturingAccount(),
    previewFilterObj: new ManufacturingAccount(),
    decimalFormat: "",
    menu: false,
    date: new Date(),
    headers: [
      { text: "Account Code", sortable: false, width: "1%" },
      { text: "Account Name", sortable: false, width: "1%" },
      { text: "Nature", sortable: false, width: "1%" },
      { text: "Amount", sortable: false, width: "1%", align: "right" },
      { text: "Amount(%)", sortable: false, width: "1%", align: "right" },
      { text: "", sortable: false, width: "1%", align: "right" },
    ],
  }),

  created() {
    //for deep linking
    this.decimalFormat = commonService.formatdecimal();
    if(this.user.shop){
      this.setShop([this.user.shop]);
    }
    this.getFinanceSettingList();
  },
  methods: {
    onSearch() {
      this.responseError = "";
      this.previewFilterObj.shopIds = this.queryParams.shopIds.join();
      this.previewFilterObj.fromMonth = this.queryParams.fromMonth;
      this.previewFilterObj.toMonth = this.queryParams.toMonth;
      this.previewFilterObj.balanceType = this.queryParams.balanceType;
      this.previewFilterObj.financeSettingId = this.queryParams.financeSettingId;
      if (!this.queryParams.financeSettingId) {
        this.responseError = "Please Select Finance setting";
      } else if (this.queryParams.shopIds.length == 0) {
        this.responseError = "Please select shop";
      } else {
        this.responseError = "";
        this.getIncomeStatementForPreview();
      }
    },

    setShop(selectedShopList) {
      this.shopCode = selectedShopList.map((s) => s.code).join();
      this.shopName = selectedShopList.map((s) => s.name).join();
      this.queryParams.shopIds = selectedShopList.map((s) => s.id);
    },

    getIncomeStatementForPreview() {
      this.showListLoading = true;
      manufacturingAccountService
        .getManufacturingAccountForPreview(this.previewFilterObj)
        .then((res) => {
          this.manufacturingAccount = res.data.manufacturingAccount;
          if (this.oldManufacturingAccount.id) {
            this.manufacturingAccount.id = this.oldManufacturingAccount.id;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    clear() {
      this.queryParams.shopIds = [];
      this.previewFilterObj = new ManufacturingAccount();
      this.shopCode = "";
      this.responseError = "";
      if (!this.manufacturingAccount.id) {
        this.manufacturingAccount = new ManufacturingAccount();
      } else {
        this.manufacturingAccount = JSON.parse(
          JSON.stringify(this.oldManufacturingAccount)
        );
      }
    },
    goBack() {
      this.$router.push("/income-statements");
    },

    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.response = err.response.data.message;
          }
        });
    },
    bindMonth(id) {
      let financeSetting = commonService.search(
        "id",
        id,
        this.financeSettingList
      );
      this.minMonth = financeSetting.startMonth;
      this.maxMonth = financeSetting.endMonth;
      this.queryParams.fromMonth = financeSetting.startMonth;
      this.queryParams.toMonth = financeSetting.endMonth;
    },
    exportMAPreview() {
      this.exportLoading = true;
      manufacturingAccountService
        .exportManufacturingAccountPreview(this.previewFilterObj, this.shopCode)
        .then((res) => {
          commonService.downloadE(res);
        });
      this.exportLoading = false;
    },
  },
};
</script>
